<template>
  <div class="clearfix">
    <vs-input
      v-validate="'required|min:3'"
      data-vv-validate-on="blur"
      label-placeholder="Name"
      name="displayName"
      placeholder="Name"
      v-model="displayName"
      class="w-full"
    />
    <span class="text-danger text-sm">{{ errors.first('displayName') }}</span>
    
    <vs-input
      v-validate="'required|min:3'"
      data-vv-validate-on="blur"
      label-placeholder="ssm #"
      name="ssm"
      placeholder="SSM #"
      v-model="ssm"
      class="w-full"
    />
    <span class="text-danger text-sm">{{ errors.first('ssm') }}</span>

    <vs-input
      v-validate="'required|email'"
      data-vv-validate-on="blur"
      name="email"
      type="email"
      label-placeholder="Email"
      placeholder="Email"
      v-model="email"
      class="w-full mt-6"
    />
    <span class="text-danger text-sm">{{ errors.first('email') }}</span>

    <vs-input
      ref="password"
      type="password"
      data-vv-validate-on="blur"
      v-validate="'required|min:6'"
      name="password"
      label-placeholder="Password"
      placeholder="Password"
      v-model="password"
      class="w-full mt-6"
    />
    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

    <vs-input
      type="password"
      v-validate="'min:6|confirmed:password'"
      data-vv-validate-on="blur"
      data-vv-as="password"
      name="confirm_password"
      label-placeholder="Confirm Password"
      placeholder="Confirm Password"
      v-model="confirm_password"
      class="w-full mt-6"
    />
    <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

    <vs-divider /> 
    <router-link to="/login" >Go to Login</router-link>
    <vs-button class="float-right" @click="registerUserJWt" :disabled="!validateForm">Register</vs-button>
   
       <h5 class="mt-4">Need Help?</h5>
       <p>Email: my.procurement@altusmalaysia.com</p>
       <p>Phone No.: 03-77338975</p>
  
  </div>
</template>

<script>
import axios from "@/axios.js";
import { alertMixin } from "../../../mixin/alertMixin";
import { mapGetters } from "vuex";
export default {
  mixins: [alertMixin],
  data() {
    return {
      displayName: "",
      email: "",
      ssm: "",
      password: "",
      confirm_password: "",
      isTermsConditionAccepted: true
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
    validateForm() {
      return (
        !this.errors.any() &&
        this.displayName != "" &&
        this.ssm != "" &&
        this.email != "" &&
        this.password != "" &&
        this.confirm_password != "" &&
        this.isTermsConditionAccepted === true
      );
    },
    theToken() {
      var token = this.getToken;
    }
  },
  methods: {
    login() {
      this.$router.push("/login").catch(() => {});
    },
    registerUserJWt() {
      // If form is not validated or user is already login return
      if (!this.validateForm) return;

      const payload = {
        name: this.displayName,
        ssm: this.ssm,
        email: this.email,
        password: this.password,
        password_confirmation: this.confirm_password,
        role: '{"id":1,"label":"vendor"}'
      };

      axios({
        method: "post",
        url: "/registerVendor",
        data: payload
      })
        .then(response => {
          this.decodeSuccessFromAxios(response, "Registration Successful!!!");

          this.$store.dispatch("updateToken", response.data.token);
          this.$store.dispatch("updatePermission", response.data.permission);

          this.$router.push("/login").catch(() => {});
        })
        .catch(error => {
          this.decodeErrorFromAxios(error);
        });
    }
  }
};
</script>

